<div class="d-flex" #choiceWrap>
  <div class="ingredients" *ngIf="!!unsatisfiedIngredientChoice">
    <select [ngClass]="{'text-muted': !selectedIngredient}" name="ingredient"
            [ngModel]="selectedIngredient ? selectedIngredient.name : unsatisfiedIngredientChoice.name"
            (ngModelChange)="onIngredientChange($event)"
            class="form-control primary-bg-color primary-text-color fw-500 ingredient ingredient-options"
            [attr.aria-label]="'component.single_ingredient_choice.ingredient_options' | translate">
            <option *ngIf="selectedIngredient" [value]='selectedIngredient.name' hidden selected></option>
            <option *ngIf="!selectedIngredient" [value]='unsatisfiedIngredientChoice.name' disabled selected>{{'component.single_ingredient_choice.placeholder' | translate: {choiceName: unsatisfiedIngredientChoice.name} }}</option>
            <option class="primary-text-color" *ngFor='let ingredient of unsatisfiedIngredientChoice.ingredients | availableSize:selectedSizePrice'
              [ngValue]='ingredient.name'>
        {{ingredient.name}}
      </option>
    </select>
  </div>
  <fts-qualifier-choice
    *ngIf='hasQualifiers && !!selectedIngredient'
    class='ingredient-qualifiers'
    [orderedQualifiers]='qualifiers'
    [qualifiers]='selectedIngredient?.qualifiers'
    [visible]='true'
    [size]='selectedIngredient?.sizePrices[0].size'
    [isHalf]='false'
    [popoverContextEl]="choiceWrapRef"
    (qualifierChange)="onQualifierChange($event)"
  ></fts-qualifier-choice>
</div>
